import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styled from "@emotion/styled";
import {
  PresentationSectionSidebar,
  PresentationSectionSidebarAction,
} from "./PresentationSectionSidebar";

const SectionContent = styled.div`
  position: relative;

  &:hover .quick-sidebar {
    opacity: 1;
    pointer-events: auto;
  }

  @media (hover: none) {
    .quick-sidebar {
      opacity: 1;
      pointer-events: auto;
    }
  }
`;

const SectionBody = styled.div<{ $hidden: boolean }>`
  opacity: ${(p) => (p.$hidden ? 0.4 : 1)};
  transition: opacity 0.2s ease-in-out;
`;

export const SectionFooterWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(50%);
  z-index: 6;
`;

interface Props {
  id: string;
  children: React.ReactNode;
  footer: React.ReactNode;
  quickActions?: PresentationSectionSidebarAction[];
  isHidden?: boolean;
}

export const SortablePresentationSection = ({
  id,
  children,
  footer,
  quickActions,
  isHidden,
}: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    position: "relative",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <SectionContent>
        <PresentationSectionSidebar
          dragHandleRef={setActivatorNodeRef}
          dragHandleAttributes={attributes}
          dragHandleListeners={listeners}
          actions={quickActions}
        />
        <SectionBody $hidden={!!isHidden}>{children}</SectionBody>
      </SectionContent>
      <SectionFooterWrapper>{footer}</SectionFooterWrapper>
    </div>
  );
};
